import React, { useEffect, useState } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { RTdatabase } from '../firebase';
import { ref, push, onValue, child, set } from "firebase/database";

export function Navigation() {
    //(Function: ToTop) Go to top after switch page
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    const [whatColor, setwhatColor] = useState({ color: "black" })
    let currentUser = localStorage.getItem("currentLoginUser")
    useEffect(() => {
        if (localStorage.getItem("currentLoginUser") !== null) {
            setwhatColor({ color: "#d4d4d4" })
        }
    }, [currentUser])

    // const dbRef = ref(RTdatabase);
    // const userRef = push(child(dbRef, "onlineUsers"));
    // let currentUser2 = currentUser
    // if (currentUser === null) {
    //     currentUser2 = getRandomInt(10000, 99999)
    // }
    // const currentUserRef = child(userRef, currentUser2);
    // set(currentUserRef, {
    //     username: currentUser2,
    //     online: true,
    // });
    // window.addEventListener("unload", () => {
    //     set(currentUserRef, {
    //         username: currentUser2,
    //         online: false,
    //     });
    // });

    // onValue(userRef, (snapshot) => {
    //     const users = snapshot.val();
    //     const onlineUsers = Object.values(users).filter((user) => user.online);
    //     // console.log("在线用户列表：", onlineUsers);
    //     localStorage.setItem("currentOnlineUser", JSON.stringify(onlineUsers));
    // });

    return (
        <div>
            <nav id="forBig">
                <div id="img">
                    <img
                        draggable={false}
                        id="logo"
                        src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/logo.png?v=1678111937949"
                        alt="logo"
                    />
                </div>
                <div id="menu">
                    <ul className="breadcrumb">
                        <li><NavLink to={"/main"} onClick={topFunction}>Home<span className="material-symbols-outlined">home</span></NavLink></li>
                        <li><NavLink to={"/profile"} onClick={topFunction}>Profile<span className="material-symbols-outlined">account_circle</span></NavLink></li>
                        <li><NavLink to={"/login"} onClick={topFunction} style={whatColor}>Login/Signup<span className="material-symbols-outlined" style={whatColor}>login</span></NavLink></li>
                    </ul>
                </div>
                <div id="line"></div>
            </nav>

            <div id="nav_forSmall">
                <div>
                    <img
                        draggable={false}
                        id="logo"
                        src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/logo.png?v=1678111937949"
                        alt="logo" />
                    <img
                        draggable={false}
                        id="logo"
                        src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/logoName.png?v=1678111941744"
                        alt="logo" />
                </div>
            </div>
        </div>
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 